const allocationBaseValue = (value) => {
  const numberValue = Number(value)
  return Number.isFinite(numberValue) ? numberValue : 0
}

export const allocationTotal = (values) =>
  (Array.isArray(values) ? values : []).reduce(
    (acc, value) => acc + allocationBaseValue(value),
    0
  )

export const allocationPercent = (value, total) => {
  const totalNumber = Number(total)
  if (!Number.isFinite(totalNumber) || totalNumber === 0) return 0
  return allocationBaseValue(value) / totalNumber
}
